<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>车辆出车统计</h4>
    </div>
    <el-tabs v-model="activeName" style="margin-left:10px;" type="card" @tab-click="handleClick">
      <el-tab-pane label="平均出车趟数" name="first">
        <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
      <el-form-item label="派车时间:" prop="searchDate">
        <el-date-picker
          v-model="searchFrom.startTime"
          size="mini"
          type="date"
          :editable=false
          :clearable=false
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom.endTime"
          size="mini"
          :clearable=false
          :editable=false
          placeholder="选择日期"
          type="date"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='00DP001B001' >查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick" btnCode='00DP001B002'  >重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  btnCode='001P00BB001' v-if="btnFlg[0]" @click="firstDaoChu" >导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div  class="table" :style="{height:h}" v-loading='tabLoading'>
      <el-table
        :data="avgList"
        ref="avgList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="fleetName"  label="车队"  width="230" align="center" ></el-table-column>
        <el-table-column v-for="(item,index) in dateList"  :prop=item align="center" :key="index" :label=item width="175">
        </el-table-column>
      </el-table>
    </div>
      </el-tab-pane>
       <el-tab-pane label="车辆出勤情况" name="second">
         <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="派车时间:" prop="searchDate">
        <el-date-picker
          v-model="searchFrom1.startTime"
          size="mini"
          type="date"
          :editable=false
          :clearable=false
          placeholder="选择日期">
        </el-date-picker>&nbsp;-&nbsp;&nbsp;
        <el-date-picker
          v-model="searchFrom1.endTime"
          size="mini"
          :clearable=false
          :editable=false
          placeholder="选择日期"
          type="date"
        ></el-date-picker>
      </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick2" btnCode='001P00BB002' v-if="btnFlg[1]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick2" btnCode='001P00BB003' v-if="btnFlg[2]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  btnCode='001P00BB004' v-if="btnFlg[3]" @click="firstDaoChu2">导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoadingB'>
      <el-table
        :data="attendanceList"
        ref="attendanceList"
        border
        height="100%"
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date"  width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="fleetName" label="车队"  width="230" align="center"></el-table-column>
        <el-table-column v-for="(item,index) in dateList" :prop=item align="center" :key="index" :label=item width="175"></el-table-column>
      </el-table>
    </div>
    </el-tab-pane>
    <el-tab-pane label="车辆出车明细" name="three">
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom2" ref="searchFrom2" class="demo-form-inline" label-width="110px" size="mini">
        <div class=" inpBox">
          <el-form-item label="派车时间:" prop="searchDate">
            <el-date-picker
              v-model="searchFrom2.startTime"
              size="mini"
              type="date"
              :editable=false
              :clearable=false
              placeholder="选择日期">
            </el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom2.endTime"
              size="mini"
              :clearable=false
              :editable=false
              placeholder="选择日期"
              type="date">
            </el-date-picker>
        </el-form-item>
        </div>
       <div class="searchBtnBox">
       <el-form-item>
          <el-button type="primary" @click="searchClick3" btnCode='00DP001B001' >查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="chongZhiClick3" btnCode='00DP001B002'  >重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  btnCode='001P00BB005' v-if="btnFlg[4]" @click="firstDaoChu3">导出</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}" v-loading='tabLoadingC'>
      <el-table
        :data="detailList"
        ref="detailList"
        border
        height="100%"
        bordersize="mini"
        style="width: 100%;margin-top:10px;"
        center
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date"  width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="vehicleNo" label="车牌号" width="120" align="center"></el-table-column>
        <el-table-column prop="fleetName" label="车队" align="center" width="230"></el-table-column>
        <el-table-column v-for="(item,index) in dateList" :prop=item align="center" :key="index" :label=item width="175"></el-table-column>
        <el-table-column prop="sum" label="总计" align="center"></el-table-column>
      </el-table>
    </div>
    <div>
        <el-pagination background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchFrom2.pageNo"
          :page-sizes="[10,15,20,25,50,100]"
          :page-size="searchFrom2.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <!-- 分页 10,25,50,100-->
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import {
  fleetList,
  getDictionaryList, // 字典
  avgSendCar,
  fleetSendCarCount, // 出勤
  vehSendCount // 明细
} from '@/api/zhb-sgHarbour'
import { getBtn } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      activeName: 'first',
      // 按钮
      btnFlg: [],
      btnIdArr: ['001P00BB001', '001P00BB002', '001P00BB003',
        '001P00BB004', '001P00BB005'],
      title: '',
      h: '500px',
      total: 0,
      avgList: [], // 平均出车趟数表格数据
      attendanceList: [], // 车辆出勤情况表格数据
      detailList: [], // 车辆出车明细
      searchFrom: {
        startTime: '',
        endTime: ''
      },
      searchFrom1: {
        startTime: '',
        endTime: ''
      },
      searchFrom2: {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      },
      fleetOptions: [],
      tabList: [],
      dateList: [],
      total1: 0,
      tabLoading: false,
      tabLoadingB: false,
      tabLoadingC: false,
      expireTimeOption: {
        disabledDate (date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() > Date.now() - 24 * 60 * 60 * 1000
        }
      },
      endTimeDisabled: true,
      expireTimeOptionB: {
        disabledDate (date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() > Date.now() - 24 * 60 * 60 * 1000
        }
      },
      endTimeDisabledB: true,
      expireTimeOptionC: {
        disabledDate (date) {
          // disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() > Date.now() - 24 * 60 * 60 * 1000
        }
      },
      endTimeDisabledC: true,
      detailTab: []
    }
  },
  created () {
    this.fleetOptionsInit()
    this.getToDay()
    this.getSeatchData()
    this.getDictionaryList()
    this.btnFlg = getBtn(this.btnIdArr, '/sgStatistics/vehicleStatistics')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 200) + 'px'
  },
  methods: {
    startTimeChange (val) {
      var dateTime = new Date(val)
      dateTime = dateTime.setDate(dateTime.getDate() + 1)
      dateTime = new Date(dateTime)
      // console.log(this.timeStamp(dateTime),'val')
      this.searchFrom.endTime = this.timeStamp(dateTime)
      this.searchFrom.startTime = this.timeStamp(this.searchFrom.startTime)
      this.getSeatchData()
      // this.endTimeDisabled = true
    },
    startTimeChangeB (val) {
      var dateTime = new Date(val)
      dateTime = dateTime.setDate(dateTime.getDate() + 1)
      dateTime = new Date(dateTime)
      // console.log(this.timeStamp(dateTime),'val')
      this.searchFrom1.endTime = this.timeStamp(dateTime)
      this.searchFrom1.startTime = this.timeStamp(this.searchFrom1.startTime)
      this.getStatistics()
      // this.endTimeDisabled = true
    },
    startTimeChangeC (val) {
      var dateTime = new Date(val)
      dateTime = dateTime.setDate(dateTime.getDate() + 1)
      dateTime = new Date(dateTime)
      // console.log(this.timeStamp(dateTime),'val')
      this.searchFrom2.endTime = this.timeStamp(dateTime)
      this.searchFrom2.startTime = this.timeStamp(this.searchFrom2.startTime)
      this.getDetailsList()
      // this.endTimeDisabled = true
    },
    fleetOptionsInit () {
      fleetList().then(res => {
        this.fleetOptions = res
        this.fleetOptions.unshift({ 'fleet': '', 'fleetName': '全部' })
      })
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'fleet_name'
      }).then(res => {
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年月日格式化
    timeStamp: function (value) {
      if (!value) return ''
      var now = new Date(value)
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    timeStamp2: function (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 28800000)) // 当天的早8点时间戳
      let nowDate = (new Date()).getTime()
      let morningTime = new Date(dateStartStr).getTime()
      if (nowDate > morningTime) { // 86400000 1天的毫秒
        this.searchFrom1.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 7))
        this.searchFrom1.endTime = this.timeStamp(new Date(dateStartStr).getTime())
        this.searchFrom2.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 7))
        this.searchFrom2.endTime = this.timeStamp(new Date(dateStartStr).getTime())
        this.searchFrom.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 7))
        this.searchFrom.endTime = this.timeStamp(new Date(dateStartStr).getTime())
      } else {
        // 昨天的时间
        this.searchFrom1.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 6))
        this.searchFrom1.endTime = this.timeStamp(new Date(dateStartStr).getTime() - 86400000)
        this.searchFrom2.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 6))
        this.searchFrom2.endTime = this.timeStamp(new Date(dateStartStr).getTime() - 86400000)
        this.searchFrom.startTime = this.timeStamp(new Date(dateStartStr).getTime() - (86400000 * 6))
        this.searchFrom.endTime = this.timeStamp(new Date(dateStartStr).getTime() - 86400000)
      }
    },
    // tab切换
    handleClick (tab, event) {
      this.initTableDate()
      if (tab.index == 0) {
        this.getToDay()
        this.getSeatchData()
        this.searchFrom1 = {
          startTime: this.timeStamp(this.searchFrom1.startTime),
          endTime: this.timeStamp(this.searchFrom1.endTime)
        }
        this.searchFrom2 = {
          startTime: this.timeStamp(this.searchFrom2.startTime),
          endTime: this.timeStamp(this.searchFrom2.endTime),
          pageNo: 1,
          pageSize: 10
        }
      } else if (tab.index == 1) {
        this.getToDay()
        this.getStatistics()
        this.searchFrom = {
          startTime: this.timeStamp(this.searchFrom.startTime),
          endTime: this.timeStamp(this.searchFrom.endTime)
        }
        this.searchFrom2 = {
          startTime: this.timeStamp(this.searchFrom2.startTime),
          endTime: this.timeStamp(this.searchFrom2.endTime),
          pageNo: 1,
          pageSize: 10
        }
      } else if (tab.index == 2) {
        this.getToDay()
        this.getDetailsList()
        this.searchFrom = {
          startTime: this.timeStamp(this.searchFrom.startTime),
          endTime: this.timeStamp(this.searchFrom.endTime)
        }
        this.searchFrom1 = {
          startTime: this.timeStamp(this.searchFrom1.startTime),
          endTime: this.timeStamp(this.searchFrom1.endTime)
        }
      }
    },
    initTableDate () {
      this.tableList = []
      this.dateList = []
    },
    // 趟数
    getSeatchData () {
      this.tabLoading = true
      avgSendCar({
        startTime: this.timeStamp(this.searchFrom.startTime),
        endTime: this.timeStamp(this.searchFrom.endTime)
      }).then(res => {
        this.avgList = []
        this.dateList = []
        this.tabLoading = false
        this.avgList = res.dataList
        this.dateList = res.dateStringList
      }).catch(err => {
        this.tabLoading = false
        this.$message.error(err.message)
      })
    },
    // 出勤
    getStatistics () {
      this.tabLoadingB = true
      fleetSendCarCount({
        startTime: this.timeStamp(this.searchFrom1.startTime),
        endTime: this.timeStamp(this.searchFrom1.endTime)
      }).then(res => {
        this.attendanceList = []
        this.dateList = []
        this.tabLoadingB = false
        this.attendanceList = res.fleetInfo
        this.dateList = res.dateStringList
      }).catch(err => {
        this.tabLoadingB = false
        this.$message.error(err.message)
      })
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData()
    },
    searchClick () {
      this.getSeatchData()
    },
    searchClick2 () {
      this.getStatistics()
    },
    chongZhiClick2 () {
      this.searchFrom1 = {}
      this.getToDay()
      this.getStatistics()
    },
    // 明细
    getDetailsList () {
      this.tabLoadingC = true
      vehSendCount({
        pageNo: this.searchFrom2.pageNo,
        pageSize: this.searchFrom2.pageSize,
        startTime: this.timeStamp(this.searchFrom2.startTime),
        endTime: this.timeStamp(this.searchFrom2.endTime)
      }).then(res => {
        this.detailList = []
        this.dateList = []
        this.tabLoadingC = false
        this.detailList = res.vehicleInfoList
        this.dateList = res.dateStringList
        this.total = res.pageInfo.total
      }).catch(err => {
        this.tabLoadingC = false
        this.$message.error(err.message)
      })
    },
    searchClick3 () {
      this.getDetailsList()
    },
    chongZhiClick3 () {
      this.searchFrom2 = {
        pageNo: 1,
        pageSize: 10
      }
      this.getToDay()
      this.getDetailsList()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom2.pageSize = val
      this.getDetailsList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom2.pageNo = val
      this.getDetailsList()
    },
    // 每页条数
    handleSizeChangeA (val) {
      this.searchFrom1.pageSize = val
      this.getStatistics()
    },
    // 当前页
    handleCurrentChangeA (val) {
      this.searchFrom1.pageNo = val
      this.getStatistics()
    },
    // 点击平均出车趟数导出
    firstDaoChu () {
      let params = {
        startTime: '',
        endTime: ''
      }
      params.startTime = this.timeStamp(this.searchFrom.startTime)
      params.endTime = this.timeStamp(this.searchFrom.endTime)
      let startDate = new Date(this.searchFrom.startTime)
      let startMonth = startDate.getMonth() + 1
      let startDay = startDate.getDate()
      let startFormat = startMonth + '月' + startDay + '日'
      let endDate = new Date(this.searchFrom.endTime)
      let endMonth = endDate.getMonth() + 1
      let endDay = endDate.getDate()
      let endFormat = endMonth + '月' + endDay + '日'
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          exportExcel(
            '/zw56-zhb-ess-server/zhbess/waybill/avgSendCarExportExcel',
            params,
            '外矿运输车队  平均出车趟数（' + startFormat + '-' + endFormat + ')'
          )
        })
        .catch(() => {})
    },
    // 点击车队出勤导出
    firstDaoChu2 () {
      let params = {}
      params.startTime = this.timeStamp(this.searchFrom1.startTime)
      params.endTime = this.timeStamp(this.searchFrom1.endTime)
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          exportExcel(
            '/zw56-zhb-ess-server/zhbess/waybill/fleetSendCarCountExportExcel',
            params,
            '车队出勤统计表'
          )
        })
        .catch(() => {})
    },
    // 明细导出
    firstDaoChu3 () {
      let params = {}
      params.startTime = this.timeStamp(this.searchFrom2.startTime)
      params.endTime = this.timeStamp(this.searchFrom2.endTime)
      this.$confirm('是否进行此操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          exportExcel(
            '/zw56-zhb-ess-server/zhbess/waybill/vehSendCountExcel',
            params,
            '车队出车明细统计表'
          )
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
/deep/ .el-tabs__item {
  width:170px;
  text-align: center;
  // background-color:#ccc ;
}
/deep/ .is-active{
  background-color:#409EFF;
  color: #fff;
}
.searchBox{
  margin-left: 15px;
}
.inpBox{
  margin: 10px 0 0 -35px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
// .inpBox .el-date-editor{
//     width: 280px!important;
//  }
.searchBtnBox{
  margin-top: 10px;
  margin-left: -5px;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi{
  display: flex;
  margin-left:10px;
}
.tongJi_item{
  margin-right: 20px;
}
.tongJi_item span{
  color: red;
}
.daiPaiTop{
  width: 99%;
  margin: 20px auto;
  display: flex;
  justify-content: space-around;
  div{
    color: #909090;

  }
}
</style>
